import {ReactNode, useState} from 'react';
import {AccordionGroupContext} from './useAccordionGroup';

interface IProps<K extends string | number | null> {
    children: ReactNode;
    className?: string;
    onChange?: (key: K) => void;
    value?: K | null;
    defaultValue?: K | null;
    unmountOnExit?: boolean;
}

export const MeinAccordionGroup = <K extends string | number | null>({
    children,
    onChange,
    className,
    value,
    defaultValue = null,
    unmountOnExit = false,
}: IProps<K>) => {
    const [current, setCurrent] = useState<K | null>(value || defaultValue);

    const onSelect = (key: K) => {
        setCurrent(key);
        onChange?.(key);
    };

    return (
        <div className={className}>
            <AccordionGroupContext.Provider
                value={{
                    onSelect: onSelect as (key: string | number | null) => void,
                    current: value !== undefined ? value : current,
                    shouldGroupUnmountOnExit: unmountOnExit,
                }}
            >
                {children}
            </AccordionGroupContext.Provider>
        </div>
    );
};
